module.exports = __webpack_public_path__ + "media/images/rokkasen_zh_hant-891cc7244870a9695692682401d69314.jpg";